import * as EnvVars from '@/env-vars';

export function getEnvVar(nombreVariable){
  let valorVariable = EnvVars[nombreVariable];
  let variableExiste = (valorVariable !== undefined);
  
  if(!variableExiste){
    throw `Variable '${nombreVariable}' no está definida en ambiente`;
  }
  
  return valorVariable;
}
